export const DEFAULT_COOKIE_OPTIONS = {
  path: '/',
  domain: 'centra.ai',
};

/** Срок жизни refresh токена 2 недели */
export const REFRESH_TOKEN_MAX_AGE_MINUTE = 60 * 24 * 7 * 2;
/** Срок жизни access токена 5 минут */
export const ACCESS_TOKEN_MAX_AGE_MINUTE = 5;
